import {DocLanguageType, getFileLanguageTypeLangKey} from "definitions/DocLanguageType";
import {AdmissionType, getAdmissionTypeLangKey, getUserStateLangKey} from "definitions/AdmissionType";
import {SsqImages} from "images/SsqImages";
import React from "react";
import deleteIconRed from 'images/common/delete-icon-red.svg';
import deleteIconGray from 'images/common/delete-icon-gray.svg';

export const makeDocLanguageString = (getTranslation: Function, docLanguages: string[]): string => {
  let docLanguageString: string = "";

  if (!docLanguages || docLanguages.length === 0) {
    return "-";
  }

  let isFirst: boolean = false;

  let docLanguageTypeAll = getTranslation(getFileLanguageTypeLangKey(DocLanguageType.ALL));
  let docLanguageTypeKO = getTranslation(getFileLanguageTypeLangKey(DocLanguageType.KO));
  let docLanguageTypeEN = getTranslation(getFileLanguageTypeLangKey(DocLanguageType.EN));
  let docLanguageTypeETC = getTranslation(getFileLanguageTypeLangKey(DocLanguageType.ETC));

  if (docLanguages.filter(docLanguage => docLanguage == DocLanguageType.ALL).length > 0) {
    docLanguageString = docLanguageString + docLanguageTypeAll;
    isFirst = true;
  }
  if (docLanguages.filter(docLanguage => docLanguage == DocLanguageType.KO).length > 0) {
    isFirst ? docLanguageString = docLanguageString + "/" + docLanguageTypeKO : docLanguageString = docLanguageString + docLanguageTypeKO;
    isFirst = true;
  }
  if (docLanguages.filter(docLanguage => docLanguage == DocLanguageType.EN).length > 0) {
    isFirst ? docLanguageString = docLanguageString + "/" + docLanguageTypeEN : docLanguageString = docLanguageString + docLanguageTypeEN;
    isFirst = true;
  }
  if (docLanguages.filter(docLanguage => docLanguage == DocLanguageType.ETC).length > 0) {
    isFirst ? docLanguageString = docLanguageString + "/" + docLanguageTypeETC : docLanguageString = docLanguageString + docLanguageTypeETC;
  }

  return docLanguageString;
};

export const renderAdmissionTypeWithIcon = (getTranslation: Function, admission: string) => {
  return <>
    <span>
      {admission == AdmissionType.NOT_APPROVED && <img alt={"admission_alarm.svg"} src={SsqImages.common.icon.admissionnot()}/>}
      {admission == AdmissionType.REJECTED && <img alt={"admission_alarm.svg"} src={SsqImages.common.icon.admissionreject()}/>}
      {admission == AdmissionType.APPROVED && <img alt={"admission_alarm.svg"} src={SsqImages.common.icon.admissionapproved()}/>}
      {admission == AdmissionType.DEL_REQUESTED && <img alt={"delete-icon-red.svg"} src={deleteIconRed}/>}
      {admission == AdmissionType.DELETED && <img alt={"delete-icon-gray.svg"} src={deleteIconGray}/>}
    </span>
    <span>{getTranslation(getAdmissionTypeLangKey(admission))}</span>
  </>;
};

export const renderUserAdmissionTypeWithIcon = (getTranslation: Function, admission: string) => {
  return <>
    <span>
      {admission == AdmissionType.NOT_APPROVED && <img alt={"admission_alarm.svg"} src={SsqImages.common.icon.admissionnot()}/>}
      {admission == AdmissionType.REJECTED && <img alt={"admission_alarm.svg"} src={SsqImages.common.icon.admissionreject()}/>}
      {admission == AdmissionType.APPROVED && <img alt={"admission_alarm.svg"} src={SsqImages.common.icon.admissionapproved()}/>}
    </span>
    <span>{getTranslation(getUserStateLangKey(admission))}</span>
  </>;
};

